import React from 'react';
import { useMarket } from '../context/MarketContext';
import { toEAT } from '../utils/time';

function formatTimestamp(time: string): string {
  if (!time) return '—';
  try {
    const date = new Date(time);
    if (!isNaN(date.getTime())) {
      return toEAT(date);
    }
    return time;
  } catch {
    return time;
  }
}

export default function RecentTradesPanel() {
  const { recentTrades } = useMarket();
  return (
    <div style={{ background:'#1e293b', padding:20, borderRadius:8, border:'1px solid #334155' }}>
      <h3 style={{ margin:'0 0 16px 0', fontSize:16, fontWeight:600 }}>Recent Trades</h3>
      <div style={{ maxHeight:200, overflowY:'auto' }}>
        {recentTrades.length === 0 ? (
          <div style={{ color:'#94a3b8', fontSize:12, textAlign:'center', padding:20 }}>No trades yet.</div>
        ) : (
          recentTrades.map((t,i)=>(
            <div key={i} style={{
              display:'flex', justifyContent:'space-between', alignItems:'center',
              padding:'8px 0', borderBottom: i<recentTrades.length-1 ? '1px solid #334155' : 'none'
            }}>
              <span style={{ fontSize:11, color:'#94a3b8' }}>{formatTimestamp(t.time)}</span>
              <span style={{ fontSize:13, fontWeight:600, color: t.side==='buy' ? '#10b981' : '#ef4444' }}>
                {t.price > 0 ? t.price.toFixed(2) : '—'}
              </span>
              <span style={{ fontSize:12, color:'#94a3b8' }}>{t.size.toLocaleString()}</span>
              <span style={{ fontSize:11, fontWeight:600, color: t.side==='buy' ? '#10b981' : '#ef4444', textTransform:'uppercase' }}>
                {t.side}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
